import React, { useRef } from 'react'
import { withStyles, Button } from '@material-ui/core'
import { withRouter } from 'react-router'

import { useEventListener } from 'Utils/hooks'
import L from 'Components/L'
import IconDisplayHorizontalSuccess from 'Icons/IconDisplayHorizontalSuccess'
import urlParamsEnum from 'enums/urlParams'
import addURLParamsToLaunchURL from 'Components/Configurator/Util/addURLParamsToLaunchURL'
import Type from 'Components/Type'
import { CardHead, StyledRadioCard, RadioCardInner, configuratorStyles } from '../Configurator-styles'
import RadioCard from '../RadioCard'

export const LaunchCard = withRouter(
  // @ts-ignore
  withStyles(configuratorStyles)(props => {
    const {
      classes,
      cardTitle,
      cardIcon,
      noMobileCardIcon,
      cardTitleOne,
      flow,
      profile,
      simulation,
      collection,
      options,
      urlSuffix,
      getVal,
      getLaunchURL,
      variant,
      disabledFallback,
      setProfileOptions,
      defaultDescription,
      shouldHideMobileOutline,
    } = props

    const Icon = noMobileCardIcon && simulation.mobileToggle === 'false' ? noMobileCardIcon : cardIcon

    const index = getVal(profile, simulation)
    const noneSelected = index === -1
    let defaultOptionLabel
    let defaultOptionDescription
    let DefaultIcon = IconDisplayHorizontalSuccess
    let availableOptions = 0

    for (let i = 0; i < options.length; i++) {
      if (!options[i].isDisabled(profile, simulation)) {
        if (i === disabledFallback) {
          defaultOptionLabel = options[i].label
          defaultOptionDescription = options[i].description
          DefaultIcon = options[i].defaultImage ? options[i].defaultImage : options[i].image
        }
        availableOptions++
      }
    }

    const innerRef = useRef(null)
    const handleKeydown = e => {
      if (e.keyCode === 13 && !e.Handled) {
        e.Handled = true
        innerRef.current.click()
      }
    }

    useEventListener('keydown', variant === 'one' ? handleKeydown : () => {})

    const label = options?.[index]?.label || defaultOptionLabel
    const description = options?.[index]?.description || defaultOptionDescription

    return (
      <div className={classes.launchCard}>
        <L display="flex" flow="column" height="100%">
          <CardHead>
            <Type variant="labelMedium">{variant === 'one' && cardTitleOne ? cardTitleOne : cardTitle}</Type>
            <L display={{ xx: 'none', md: 'flex' }}>{variant !== 'one' && <Icon />}</L>
          </CardHead>
          <L display="grid" rows="max-content" ai="flex-start" minY="1px" gap={1.5} pT={1.5} pB={1.5} pX={1.5} grow>
            <L display="grid" gap={1.5}>
              {availableOptions > 1 ? (
                <>
                  <L
                    display="grid"
                    gap={1}
                    columns={{
                      xs: flow === 'column' ? `repeat(${options.length}, 1fr)` : `auto`,
                    }}
                  >
                    {options.map((option, idx) => {
                      const checked = noneSelected ? idx === disabledFallback : idx === index
                      const isCardDisabled = option.isDisabled(profile, simulation)
                      return (
                        <StyledRadioCard
                          key={`displayOption_${urlSuffix}_${idx}`}
                          checked={checked}
                          disabled={isCardDisabled}
                        >
                          <RadioCardInner checked={checked} disabled={isCardDisabled}>
                            <RadioCard
                              checked={checked}
                              onSelect={() => setProfileOptions(option.profileOptions)}
                              image={option.image}
                              {...option}
                            />
                          </RadioCardInner>
                        </StyledRadioCard>
                      )
                    })}
                  </L>
                  <L>
                    <Type variant="h4">
                      <span dangerouslySetInnerHTML={{ __html: label }} />
                    </Type>
                    <Type variant="body1">
                      <span dangerouslySetInnerHTML={{ __html: description }} />
                    </Type>
                  </L>
                </>
              ) : (
                <L display="grid" ji="center" gap={1.5} textAlign="center">
                  <L display="grid" gap={1} jc="center" ji="center" ac="flex-start">
                    {DefaultIcon && (
                      <L display="grid" ac="center" jc="center" height="50px" width="50px">
                        <DefaultIcon />
                      </L>
                    )}
                    <Type variant="labelLargeBold">{label}</Type>
                  </L>
                  <Type variant="body1">
                    <span dangerouslySetInnerHTML={{ __html: defaultDescription }} />
                  </Type>
                </L>
              )}
            </L>
            <L display="flex" jc="center" ai="flex-end" alignSelf="normal">
              <Button
                ref={innerRef}
                variant="contained"
                color="primary"
                onClick={() => {
                  const urlParams = {}
                  if (shouldHideMobileOutline) {
                    urlParams[urlParamsEnum.HIDE_MOBILE_OUTLINE.KEY] = urlParamsEnum.HIDE_MOBILE_OUTLINE.VALUES.TRUE
                  }
                  const launchURL = addURLParamsToLaunchURL(
                    getLaunchURL(collection, simulation, variant, urlParams),
                    urlParams,
                  )
                  if (launchURL) window.open(launchURL)
                }}
              >
                Launch
              </Button>
            </L>
          </L>
        </L>
      </div>
    )
  }),
)

export default LaunchCard
